(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5326],{

/***/ 33293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getLoadDisplayBodyType; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14345);

function getLoadDisplayBodyType(lorryTypeId, bodyType) {
    var ref, ref1, ref2;
    if (!lorryTypeId || bodyType == null) {
        return undefined;
    }
    return (ref2 = (ref = (0,_vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .getVehicleInfoByLorryType */ .sB)(lorryTypeId, "load")) === null || ref === void 0 ? void 0 : (ref1 = ref.bodyOptions) === null || ref1 === void 0 ? void 0 : ref1.find(function(option) {
        return option.id === bodyType;
    })) === null || ref2 === void 0 ? void 0 : ref2.name;
}


/***/ }),

/***/ 51834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ey": function() { return /* reexport */ load_market_route_LoadMarketRouteSection; },
  "FN": function() { return /* reexport */ getRouteLocationDisplay; }
});

// UNUSED EXPORTS: getStateCodeById

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/icons/ArrowRightGrey.svg
var ArrowRightGrey = __webpack_require__(8526);
// EXTERNAL MODULE: ../core/dist/standard-icons/location-pin-outlined.svg
var location_pin_outlined = __webpack_require__(90831);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(77149);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../core/dist/standard-icons/cross-icon.svg
var cross_icon = __webpack_require__(43710);
// EXTERNAL MODULE: ../core/dist/constants/index.js + 4 modules
var constants = __webpack_require__(94204);
// EXTERNAL MODULE: ../core-ui/dist/components/DotLoader/index.js + 2 modules
var DotLoader = __webpack_require__(97871);
// EXTERNAL MODULE: ../core-ui/dist/methods/index.js + 3 modules
var methods = __webpack_require__(38920);
// EXTERNAL MODULE: ./components/homepage-v2/hooks/useHomepageV2Translation.ts
var useHomepageV2Translation = __webpack_require__(14394);
// EXTERNAL MODULE: ./services/load/useGetLoadStops.tsx
var useGetLoadStops = __webpack_require__(38038);
// EXTERNAL MODULE: ./components/homepage-v2/detailed-route/DetailedRouteModal.module.scss
var DetailedRouteModal_module = __webpack_require__(19174);
var DetailedRouteModal_module_default = /*#__PURE__*/__webpack_require__.n(DetailedRouteModal_module);
;// CONCATENATED MODULE: ./components/homepage-v2/detailed-route/DetailedRouteModal.tsx















function formatStopBodyAddress(info) {
    var ref = info || {}, description = ref.description, address = ref.address;
    return (0,methods/* getJoinedStringFromArray */.D$)([
        description,
        address
    ], ", ", true);
}
function formatStopHeaderAddress(info) {
    var ref;
    return (info === null || info === void 0 ? void 0 : (ref = info.address) === null || ref === void 0 ? void 0 : ref.trim()) || "";
}
function toLatLng(info) {
    if ((info === null || info === void 0 ? void 0 : info.latitude) == null || (info === null || info === void 0 ? void 0 : info.longitude) == null) {
        return undefined;
    }
    return [
        info.latitude,
        info.longitude
    ];
}
function parseStopsToPoints(stops) {
    if (!stops.length) {
        return [];
    }
    var _stops = (0,_to_array/* default */.Z)(stops), src = _stops[0], rest = _stops.slice(1);
    var dest = rest.pop();
    var waypoints = (0,_to_consumable_array/* default */.Z)(rest).sort(function(a, b) {
        return Number(a.sequence) - Number(b.sequence);
    });
    return [
        {
            type: "from",
            address: formatStopBodyAddress(src),
            latLng: toLatLng(src)
        }
    ].concat((0,_to_consumable_array/* default */.Z)(waypoints.map(function(stop) {
        return {
            type: "stop",
            address: formatStopBodyAddress(stop),
            latLng: toLatLng(stop)
        };
    })), [
        {
            type: "to",
            address: formatStopBodyAddress(dest),
            latLng: toLatLng(dest)
        }
    ]).filter(function(point) {
        return point.address || point.latLng;
    });
}
function buildFallbackPoints(loadDetail) {
    if (!loadDetail) {
        return [];
    }
    var sourceAddress = loadDetail.source_formatted_address || (0,methods/* getJoinedStringFromArray */.D$)([
        loadDetail.source_city_name,
        loadDetail.source_state_name
    ], ", ", true);
    var destinationAddress = loadDetail.destination_formatted_address || (0,methods/* getJoinedStringFromArray */.D$)([
        loadDetail.destination_city_name,
        loadDetail.destination_state_name
    ], ", ", true);
    var points = [];
    if (sourceAddress) {
        points.push({
            type: "from",
            address: sourceAddress,
            latLng: toLatLng({
                latitude: loadDetail.source_latitude,
                longitude: loadDetail.source_longitude
            })
        });
    }
    if (destinationAddress) {
        points.push({
            type: "to",
            address: destinationAddress,
            latLng: toLatLng({
                latitude: loadDetail.destination_latitude,
                longitude: loadDetail.destination_longitude
            })
        });
    }
    return points;
}
function getRouteChipLabels(stops, loadDetail) {
    if (stops.length) {
        var ref, ref1;
        var _stops = (0,_to_array/* default */.Z)(stops), src = _stops[0], rest = _stops.slice(1);
        var dest = rest.pop();
        var waypoints = (0,_to_consumable_array/* default */.Z)(rest).sort(function(a, b) {
            return Number(a.sequence) - Number(b.sequence);
        });
        var labels = [];
        var sourceLabel = formatStopHeaderAddress(src) || (loadDetail === null || loadDetail === void 0 ? void 0 : (ref = loadDetail.source_city_name) === null || ref === void 0 ? void 0 : ref.trim()) || "";
        if (sourceLabel) {
            labels.push(sourceLabel);
        }
        waypoints.forEach(function(stop) {
            var label = formatStopHeaderAddress(stop);
            if (label) {
                labels.push(label);
            }
        });
        var destinationLabel = formatStopHeaderAddress(dest) || (loadDetail === null || loadDetail === void 0 ? void 0 : (ref1 = loadDetail.destination_city_name) === null || ref1 === void 0 ? void 0 : ref1.trim()) || "";
        if (destinationLabel) {
            labels.push(destinationLabel);
        }
        if (labels.length) {
            return labels;
        }
    }
    var ref2 = getRouteLocationDisplay(loadDetail), sourceCity = ref2.sourceCity, destinationCity = ref2.destinationCity;
    return [
        sourceCity,
        destinationCity
    ].filter(function(label) {
        return Boolean(label);
    });
}
var DetailedRouteModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, loadId = param.loadId, loadDetail = param.loadDetail;
    var ref, ref1;
    var t = (0,useHomepageV2Translation/* default */.Z)().t;
    var ref2 = (0,react.useState)(false), isMounted = ref2[0], setIsMounted = ref2[1];
    var response = (0,useGetLoadStops/* useGetLoadStops */.b)({
        loadId: loadId
    }, (0,_object_spread/* default */.Z)({
        enabled: isOpen && !!loadId
    }, constants/* NoSuccessErrorHandler */.jtj));
    var stops = (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.stops;
    var points = (0,react.useMemo)(function() {
        if (stops === null || stops === void 0 ? void 0 : stops.length) {
            var parsed = parseStopsToPoints(stops);
            if (parsed.length) {
                return parsed;
            }
        }
        return buildFallbackPoints(loadDetail);
    }, [
        loadDetail,
        stops
    ]);
    var routeLabels = (0,react.useMemo)(function() {
        return getRouteChipLabels(stops || [], loadDetail);
    }, [
        loadDetail,
        stops
    ]);
    var allLatLng = (0,react.useMemo)(function() {
        return points.map(function(point) {
            return point.latLng;
        }).filter(function(coords) {
            return !!coords;
        });
    }, [
        points
    ]);
    var isLoading = isOpen && !!loadId && (response.isLoading || response.isFetching) && !points.length;
    (0,react.useEffect)(function() {
        setIsMounted(true);
    }, []);
    (0,react.useEffect)(function() {
        if (!isOpen) {
            return;
        }
        var handleKeyDown = function(event) {
            if (event.key === "Escape") {
                onClose();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return function() {
            return document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        isOpen,
        onClose
    ]);
    var routeChip = (0,react.useMemo)(function() {
        return routeLabels.map(function(label, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    index > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (DetailedRouteModal_module_default()).routeChipArrow,
                        "aria-hidden": true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightGrey/* default */.Z, {})
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (DetailedRouteModal_module_default()).routeChipCity,
                        children: label
                    })
                ]
            }, "".concat(label, "-").concat(index));
        });
    }, [
        routeLabels
    ]);
    if (!isOpen || !isMounted) {
        return null;
    }
    return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (DetailedRouteModal_module_default()).overlay,
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (DetailedRouteModal_module_default()).shell,
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "detailed-route-title",
            onClick: function(event) {
                return event.stopPropagation();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (DetailedRouteModal_module_default()).heroHeader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (DetailedRouteModal_module_default()).headerRow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: (DetailedRouteModal_module_default()).title,
                                    id: "detailed-route-title",
                                    children: t("homepageV2:detailedRoute.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: (DetailedRouteModal_module_default()).closeBtn,
                                    onClick: onClose,
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cross_icon/* default */.Z, {
                                        width: 16,
                                        height: 16
                                    })
                                })
                            ]
                        }),
                        routeLabels.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (DetailedRouteModal_module_default()).routeChip,
                            children: routeChip
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (DetailedRouteModal_module_default()).content,
                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (DetailedRouteModal_module_default()).loaderWrap,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DotLoader["default"], {})
                    }) : points.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (DetailedRouteModal_module_default()).emptyState,
                        children: t("homepageV2:detailedRoute.empty")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (DetailedRouteModal_module_default()).pointList,
                        children: points.map(function(point, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (DetailedRouteModal_module_default()).pointRow,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (DetailedRouteModal_module_default()).pointMain,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (DetailedRouteModal_module_default()).pointLabel,
                                            children: point.type === "from" ? t("homepageV2:detailedRoute.from") : point.type === "to" ? t("homepageV2:detailedRoute.to") : t("homepageV2:detailedRoute.stop")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (DetailedRouteModal_module_default()).pointAddress,
                                            children: point.address || "--"
                                        })
                                    ]
                                })
                            }, "".concat(point.type, "-").concat(index));
                        })
                    })
                })
            ]
        })
    }), document.body);
};
/* harmony default export */ var detailed_route_DetailedRouteModal = (DetailedRouteModal);

;// CONCATENATED MODULE: ./components/homepage-v2/detailed-route/index.ts


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../core/dist/constants/StateList.js
var StateList = __webpack_require__(52224);
;// CONCATENATED MODULE: ./components/homepage-v2/load-market-route/getRouteLocationDisplay.ts


var getStateCodeById = function(stateId) {
    var ref;
    return (ref = StateList/* STATE_LIST.find */.t4.find(function(state) {
        return state.id === stateId;
    })) === null || ref === void 0 ? void 0 : ref.code;
};
function getCityFallback(cityName, routeLabel) {
    if (cityName === null || cityName === void 0 ? void 0 : cityName.trim()) {
        return cityName.trim();
    }
    var ref = (0,_sliced_to_array/* default */.Z)((routeLabel || "").split(","), 1), firstPart = ref[0];
    return (firstPart === null || firstPart === void 0 ? void 0 : firstPart.trim()) || (routeLabel === null || routeLabel === void 0 ? void 0 : routeLabel.trim()) || undefined;
}
function getRouteLocationDisplay(loadDetail) {
    if (!loadDetail) {
        return {};
    }
    return {
        sourceCity: getCityFallback(loadDetail.source_city_name, loadDetail.source),
        sourceState: getStateCodeById(loadDetail.source_state_id) || loadDetail.source_state_name,
        destinationCity: getCityFallback(loadDetail.destination_city_name, loadDetail.destination),
        destinationState: getStateCodeById(loadDetail.destination_state_id) || loadDetail.destination_state_name
    };
}

// EXTERNAL MODULE: ./components/homepage-v2/load-market-route/LoadMarketRouteSection.module.scss
var LoadMarketRouteSection_module = __webpack_require__(77837);
var LoadMarketRouteSection_module_default = /*#__PURE__*/__webpack_require__.n(LoadMarketRouteSection_module);
;// CONCATENATED MODULE: ./components/homepage-v2/load-market-route/LoadMarketRouteSection.tsx










var RouteLocationBlock = function(param) {
    var label = param.label, city = param.city, state = param.state, _align = param.align, align = _align === void 0 ? "left" : _align, idPrefix = param.idPrefix, side = param.side;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((LoadMarketRouteSection_module_default()).locationBlock, (0,_define_property/* default */.Z)({}, (LoadMarketRouteSection_module_default()).locationBlockRight, align === "right")),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (LoadMarketRouteSection_module_default()).locationLabel,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (LoadMarketRouteSection_module_default()).locationCity,
                id: idPrefix && side ? "".concat(idPrefix, "--").concat(side === "source" ? "source" : "destination", "--city") : undefined,
                children: city ? "".concat(city, ",") : "--"
            }),
            state ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (LoadMarketRouteSection_module_default()).locationState,
                id: idPrefix && side ? "".concat(idPrefix, "--").concat(side === "source" ? "source" : "destination", "--state") : undefined,
                children: state
            }) : null
        ]
    });
};
var LoadMarketRouteSection = function(param) {
    var loadDetail = param.loadDetail, _variant = param.variant, variant = _variant === void 0 ? "marketCard" : _variant, idPrefix = param.idPrefix, onStopsClick = param.onStopsClick, onShowRouteClick = param.onShowRouteClick;
    var ref;
    var t = (0,useHomepageV2Translation/* default */.Z)().t;
    var ref1 = (0,react.useState)(false), isRouteModalOpen = ref1[0], setIsRouteModalOpen = ref1[1];
    var ref2 = getRouteLocationDisplay(loadDetail), sourceCity = ref2.sourceCity, sourceState = ref2.sourceState, destinationCity = ref2.destinationCity, destinationState = ref2.destinationState;
    var stopsCount = (loadDetail === null || loadDetail === void 0 ? void 0 : (ref = loadDetail.stops) === null || ref === void 0 ? void 0 : ref.length) || 0;
    var canOpenRoute = Boolean(loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.id);
    var showRouteLink = variant === "bidDetails" && canOpenRoute;
    var openRouteModal = function() {
        if (canOpenRoute) {
            setIsRouteModalOpen(true);
        }
    };
    var handleStopsClick = function() {
        onStopsClick === null || onStopsClick === void 0 ? void 0 : onStopsClick();
        openRouteModal();
    };
    var handleShowRouteClick = function() {
        onShowRouteClick === null || onShowRouteClick === void 0 ? void 0 : onShowRouteClick();
        openRouteModal();
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((LoadMarketRouteSection_module_default()).routeSection, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (LoadMarketRouteSection_module_default()).routeSectionMarketCard, variant === "marketCard"), (0,_define_property/* default */.Z)(_obj, (LoadMarketRouteSection_module_default()).routeSectionBidDetails, variant === "bidDetails"), _obj)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RouteLocationBlock, {
                        label: t("mktCardV2:from"),
                        city: sourceCity,
                        state: sourceState,
                        idPrefix: idPrefix,
                        side: "source"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((LoadMarketRouteSection_module_default()).routeCenter, (0,_define_property/* default */.Z)({}, (LoadMarketRouteSection_module_default()).routeCenterBidDetails, variant === "bidDetails")),
                        children: [
                            stopsCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: classnames_default()((LoadMarketRouteSection_module_default()).routeActionBtn, (0,_define_property/* default */.Z)({}, (LoadMarketRouteSection_module_default()).routeActionBtnBidDetails, variant === "bidDetails")),
                                onClick: handleStopsClick,
                                id: idPrefix ? "".concat(idPrefix, "--stops") : undefined,
                                children: [
                                    "+",
                                    stopsCount,
                                    " ",
                                    stopsCount === 1 ? t("mktCardV2:stop") : t("mktCardV2:stops")
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()((LoadMarketRouteSection_module_default()).stopsSpacer, (0,_define_property/* default */.Z)({}, (LoadMarketRouteSection_module_default()).stopsSpacerBidDetails, variant === "bidDetails")),
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LoadMarketRouteSection_module_default()).arrowIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightGrey/* default */.Z, {})
                            }),
                            (loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.distance) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: classnames_default()((LoadMarketRouteSection_module_default()).distanceBadge, (0,_define_property/* default */.Z)({}, (LoadMarketRouteSection_module_default()).distanceBadgeBidDetails, variant === "bidDetails")),
                                id: idPrefix ? "".concat(idPrefix, "--distance") : undefined,
                                children: [
                                    Math.round(loadDetail.distance / 1000),
                                    " ",
                                    t("mktCardV2:kms")
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()((LoadMarketRouteSection_module_default()).stopsSpacer, (0,_define_property/* default */.Z)({}, (LoadMarketRouteSection_module_default()).distanceSpacerBidDetails, variant === "bidDetails")),
                                "aria-hidden": true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RouteLocationBlock, {
                        label: t("mktCardV2:to"),
                        city: destinationCity,
                        state: destinationState,
                        align: "right",
                        idPrefix: idPrefix,
                        side: "destination"
                    }),
                    showRouteLink ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: (LoadMarketRouteSection_module_default()).showRouteBtn,
                        onClick: handleShowRouteClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(location_pin_outlined/* default */.Z, {
                                className: (LoadMarketRouteSection_module_default()).showRouteIcon,
                                "aria-hidden": true
                            }),
                            t("mktCardV2:showRouteOnMap")
                        ]
                    }) : null
                ]
            }),
            canOpenRoute ? /*#__PURE__*/ (0,jsx_runtime.jsx)(detailed_route_DetailedRouteModal, {
                isOpen: isRouteModalOpen,
                onClose: function() {
                    return setIsRouteModalOpen(false);
                },
                loadId: loadDetail.id,
                loadDetail: loadDetail
            }) : null
        ]
    });
};
/* harmony default export */ var load_market_route_LoadMarketRouteSection = (LoadMarketRouteSection);

;// CONCATENATED MODULE: ./components/homepage-v2/load-market-route/index.ts




/***/ }),

/***/ 19174:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"DetailedRouteModal_overlay__D4mWu","shell":"DetailedRouteModal_shell__eASK_","heroHeader":"DetailedRouteModal_heroHeader__g29M3","headerRow":"DetailedRouteModal_headerRow__QuKPN","title":"DetailedRouteModal_title__yplTS","closeBtn":"DetailedRouteModal_closeBtn__s_n88","routeChip":"DetailedRouteModal_routeChip__86wA2","routeChipCity":"DetailedRouteModal_routeChipCity__Gn2Za","routeChipArrow":"DetailedRouteModal_routeChipArrow__HZ2LG","content":"DetailedRouteModal_content__4iHvo","loaderWrap":"DetailedRouteModal_loaderWrap__HTJ6c","emptyState":"DetailedRouteModal_emptyState__ziErD","pointList":"DetailedRouteModal_pointList__YJTIQ","pointRow":"DetailedRouteModal_pointRow__TbZVF","pointMain":"DetailedRouteModal_pointMain__ic5zA","pointLabel":"DetailedRouteModal_pointLabel__TuRyH","pointAddress":"DetailedRouteModal_pointAddress__BeLGX","mapBtn":"DetailedRouteModal_mapBtn__0duBS","mapBtnIcon":"DetailedRouteModal_mapBtnIcon__eb3ku","hpv2HeroSlideIn":"DetailedRouteModal_hpv2HeroSlideIn__n_Bi0","hpv2HeroFadeIn":"DetailedRouteModal_hpv2HeroFadeIn__PNJ7l","hpv2HeroFadeInOpacity":"DetailedRouteModal_hpv2HeroFadeInOpacity__Mw_rt","hpv2FadeUp":"DetailedRouteModal_hpv2FadeUp__tkVa_","hpv2FadeLeft":"DetailedRouteModal_hpv2FadeLeft__NXc4U","hpv2FadeRight":"DetailedRouteModal_hpv2FadeRight__5NvaA","hpv2ScaleUp":"DetailedRouteModal_hpv2ScaleUp__9ApUr","hpv2Blink":"DetailedRouteModal_hpv2Blink__mhI6_","hpv2FloatA":"DetailedRouteModal_hpv2FloatA__KmTPF","hpv2FloatB":"DetailedRouteModal_hpv2FloatB__X6BIy","hpv2DemoProgress":"DetailedRouteModal_hpv2DemoProgress__GpyZn","hpv2DemoSlideIn":"DetailedRouteModal_hpv2DemoSlideIn__wyxbA","hpv2DemoFadeIn":"DetailedRouteModal_hpv2DemoFadeIn__yM_D4","hpv2DemoScaleIn":"DetailedRouteModal_hpv2DemoScaleIn__onPf_","hpv2DemoBounce":"DetailedRouteModal_hpv2DemoBounce__jMOvM","hpv2PulseDot":"DetailedRouteModal_hpv2PulseDot__M1LId","hpv2PriceShimmer":"DetailedRouteModal_hpv2PriceShimmer__7er1f"};

/***/ }),

/***/ 77837:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"routeSection":"LoadMarketRouteSection_routeSection__v6mD0","routeSectionMarketCard":"LoadMarketRouteSection_routeSectionMarketCard__HrEfY","routeCenter":"LoadMarketRouteSection_routeCenter__391sA","arrowIcon":"LoadMarketRouteSection_arrowIcon__N45q7","locationLabel":"LoadMarketRouteSection_locationLabel__uVkkX","locationCity":"LoadMarketRouteSection_locationCity__jPDby","locationState":"LoadMarketRouteSection_locationState___zfEl","routeSectionBidDetails":"LoadMarketRouteSection_routeSectionBidDetails__ljBWa","showRouteBtn":"LoadMarketRouteSection_showRouteBtn__7tzSC","showRouteIcon":"LoadMarketRouteSection_showRouteIcon__yHmn0","locationBlock":"LoadMarketRouteSection_locationBlock__5bZeI","locationBlockRight":"LoadMarketRouteSection_locationBlockRight__q4Aby","routeCenterBidDetails":"LoadMarketRouteSection_routeCenterBidDetails__vPawt","distanceBadge":"LoadMarketRouteSection_distanceBadge__59tHK","distanceBadgeBidDetails":"LoadMarketRouteSection_distanceBadgeBidDetails__3wIQx","stopsSpacer":"LoadMarketRouteSection_stopsSpacer__ZhM9J","stopsSpacerBidDetails":"LoadMarketRouteSection_stopsSpacerBidDetails__Av4vi","distanceSpacerBidDetails":"LoadMarketRouteSection_distanceSpacerBidDetails__2HyLj","routeActionBtn":"LoadMarketRouteSection_routeActionBtn__OR0s1","routeActionBtnBidDetails":"LoadMarketRouteSection_routeActionBtnBidDetails__PpM4e","hpv2HeroSlideIn":"LoadMarketRouteSection_hpv2HeroSlideIn__n5zR5","hpv2HeroFadeIn":"LoadMarketRouteSection_hpv2HeroFadeIn__HLuKf","hpv2HeroFadeInOpacity":"LoadMarketRouteSection_hpv2HeroFadeInOpacity__jAsnj","hpv2FadeUp":"LoadMarketRouteSection_hpv2FadeUp__217T5","hpv2FadeLeft":"LoadMarketRouteSection_hpv2FadeLeft__iCxMh","hpv2FadeRight":"LoadMarketRouteSection_hpv2FadeRight__AJmHX","hpv2ScaleUp":"LoadMarketRouteSection_hpv2ScaleUp__JIAXX","hpv2Blink":"LoadMarketRouteSection_hpv2Blink__564_2","hpv2FloatA":"LoadMarketRouteSection_hpv2FloatA__VSYS0","hpv2FloatB":"LoadMarketRouteSection_hpv2FloatB__cHnOA","hpv2DemoProgress":"LoadMarketRouteSection_hpv2DemoProgress__NV_c0","hpv2DemoSlideIn":"LoadMarketRouteSection_hpv2DemoSlideIn__lr1oC","hpv2DemoFadeIn":"LoadMarketRouteSection_hpv2DemoFadeIn___sOYN","hpv2DemoScaleIn":"LoadMarketRouteSection_hpv2DemoScaleIn__8nkfx","hpv2DemoBounce":"LoadMarketRouteSection_hpv2DemoBounce__CuaxC","hpv2PulseDot":"LoadMarketRouteSection_hpv2PulseDot__yMS7k","hpv2PriceShimmer":"LoadMarketRouteSection_hpv2PriceShimmer__n40lF"};

/***/ }),

/***/ 77149:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18770);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33579);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93520);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15459);





function _toArray(arr) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ })

}]);